module.exports = __webpack_public_path__ + "static/media/29BDOS8.6838480f.jpg";